import React from 'react';

interface RightArrowDoubleIconProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  style?: React.CSSProperties;
}

const RightArrowDoubleIcon: React.FC<RightArrowDoubleIconProps> = ({ 
  width = 24, 
  height = 24, 
  color = '#161616',
  className,
  style 
}) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      width={width} 
      height={height} 
      fill="none" 
      viewBox="0 0 24 24"
      className={className}
      style={style}
    >
      <path 
        d="M6.57808 7.57613C6.81239 7.34181 7.19142 7.34181 7.42574 7.57613L11.4257 11.5761C11.6601 11.8104 11.6601 12.1895 11.4257 12.4238L7.42574 16.4238C7.19142 16.6581 6.81239 16.6581 6.57808 16.4238C6.34377 16.1895 6.34377 15.8104 6.57808 15.5761L10.1543 12L6.57808 8.42378C6.34377 8.18947 6.34377 7.81044 6.57808 7.57613ZM12.5781 7.57613C12.8124 7.34181 13.1914 7.34181 13.4257 7.57613L17.4257 11.5761C17.6601 11.8104 17.6601 12.1895 17.4257 12.4238L13.4257 16.4238C13.1914 16.6581 12.8124 16.6581 12.5781 16.4238C12.3438 16.1895 12.3438 15.8104 12.5781 15.5761L16.1543 12L12.5781 8.42378C12.3438 8.18947 12.3438 7.81044 12.5781 7.57613Z" 
        fill={color}
      />
    </svg>
  );
};

export default RightArrowDoubleIcon;

